import { MeshGradient } from '../types';

async function convertGradientToImage(gradient: MeshGradient, ratio: '1:1' | '16:9'): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    
    // Set dimensions based on ratio
    if (ratio === '1:1') {
      canvas.width = 1200;
      canvas.height = 1200;
    } else { // 16:9
      canvas.width = 1920;
      canvas.height = 1080;
    }
    
    const ctx = canvas.getContext('2d')!;

    // Create gradient
    const gradient2d = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.colors.forEach((color, index) => {
      gradient2d.addColorStop(index / (gradient.colors.length - 1), color);
    });

    // Clear any transformations
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    
    // Fill background
    ctx.fillStyle = gradient2d;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Apply rotation around center if needed
    if (gradient.angle !== 0) {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      ctx.save();
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((gradient.angle * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);
      
      ctx.putImageData(imageData, 0, 0);
      ctx.restore();
    }

    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Failed to convert to image'));
      },
      'image/png',
      1.0
    );
  });
}

export async function downloadGradient(gradient: MeshGradient, ratio: '1:1' | '16:9') {
  try {
    const fileName = gradient.name.toLowerCase().replace(/\s+/g, '-');
    const blob = await convertGradientToImage(gradient, ratio);
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}-${ratio.replace(':', 'x')}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download gradient:', error);
  }
}